import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle, useStatoInSolaLettura } from "../../../../layouts/PageHeaderExtra";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { format } from 'date-fns';
import { italianProvinces, sports } from "../../../../components/Util/enum";
import { useProfile } from "../../../../../hooks/useProfile";

import { conMotivo } from "../../../../components/Util/erroreServer";
export const AdminUserLessonsView = () => {

    const { profile, loading: profileLoading } = useProfile();
    const isFatturazioneConfirmed = profile?.club?.invoiceDataSender?.status === 'CONFIRMED';

    const { id } = useParams();

    const [loadingShowed, setLoadingShowed] = useState(false);
    const [confirmPaymentShowed, setConfirmPaymentShowed] = useState(false);
    const [confirmShowed, setConfirmShowed] = useState(false);
    const [onContinue, setOnContinue] = useState(null);
    const [confirmText, setConfirmText] = useState('');
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmLabel, setConfirmLabel] = useState('Conferma');

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ]

    const optionsPayment = [
        { value: "CASH", label: "Contanti" },
        { value: "CARD", label: "Carta di credito" },
        { value: "BANK_TRANSFER", label: "Bonifico" }
    ]

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [reloadKey, setReloadKey] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const userBookingLessons = await apiClient.getUserBookingLessonById(token, id);
                    setLoadingShowed(false);
                    
                    if(userBookingLessons) {
                        const elementFormData = {
                            lesson_name: userBookingLessons.lesson_name,
                            sportType: userBookingLessons.sportType,
                            playerName: userBookingLessons.playerName,
                            juniorName: userBookingLessons.juniorName,
                            price: userBookingLessons.price+' €',
                            startDate: userBookingLessons.bookingDate && userBookingLessons.startTime ? 
                                format(new Date(userBookingLessons.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingLessons.startTime : '',
                            endDate: userBookingLessons.bookingDate && userBookingLessons.endTime ? 
                                format(new Date(userBookingLessons.bookingDate), 'dd/MM/yyyy') + ' ' + userBookingLessons.endTime : '',
                        }

                        let status = null;
                        if(userBookingLessons.status === 'PAID') {
                            status = {
                                "label": "Pagato",
                                "class": "text-success"
                            };
                        } else if(userBookingLessons.status === 'UNPAID') {
                            status = {
                                "label": "Non pagato",
                                "class": "text-primary"
                            };
                        } else if(userBookingLessons.status === 'REFUNDED') {
                            status = {
                                "label": "Rimborsato",
                                "class": "text-warning"
                            };
                        } else if(userBookingLessons.status === 'CANCELLED') {
                            status = {
                                "label": "Eliminato",
                                "class": "text-error"
                            };
                        }

                        elementFormData.id = userBookingLessons.id;
                        elementFormData.status = status;
                        elementFormData.originalStatus = userBookingLessons.status;

                        if(userBookingLessons.receiver) {
                            elementFormData.codice_fiscale = userBookingLessons.receiver.tax_code;
                            elementFormData.email = userBookingLessons.receiver.pec;
                            elementFormData.indirizzo = userBookingLessons.receiver.address;
                            elementFormData.cap = userBookingLessons.receiver.zip_code;
                            elementFormData.citta = userBookingLessons.receiver.city;
                            elementFormData.provincia = userBookingLessons.receiver.province;
                            if(userBookingLessons.receiver.type === 'consumer') {
                                elementFormData.tipo_cliente = 'privato';
                                elementFormData.nome = userBookingLessons.receiver.first_name;
                                elementFormData.cognome = userBookingLessons.receiver.last_name;
                            } else if(userBookingLessons.receiver.type === 'business') {
                                elementFormData.tipo_cliente = 'azienda';
                                elementFormData.ragione_sociale = userBookingLessons.receiver.denomination;
                                elementFormData.partita_iva = userBookingLessons.receiver.vat_number;
                                elementFormData.codice_destinatario = userBookingLessons.receiver.sdi_code;
                            }
                        }

                        if(userBookingLessons.status !== 'UNPAID') {
                            elementFormData.is_pagato = true;
                            if(userBookingLessons.payment_method) {
                                elementFormData.modalita_pagamento = userBookingLessons.payment_method;
                            }
                        } else {
                            elementFormData.is_pagato = false;
                        }

                        // Aggiungi il campo skip_generate_document con valore di default
                        elementFormData.skip_generate_document = false;

                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id, reloadKey]);

    const [formData, setFormData] = useState({
        lesson_name: '',
        sportType: '',
        playerName: '',
        juniorName: '',
        price: '',
        status: '',
        startDate: '',
        endDate: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
        tipo_cliente: '',
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        nome: '',
        cognome: '',
        skip_generate_document: false
    });

    // Titolo della pagina = nome della lezione prenotata, appena caricato.
    usePageTitle(formData?.lesson_name);

    // Stato in sola lettura accanto al titolo (da qui non si cambia)
    useStatoInSolaLettura(formData?.status?.label, formData?.originalStatus === 'PAID' ? 'attivo' : formData?.originalStatus === 'UNPAID' ? 'non-attivo' : 'bozza');

    useEffect(() => {
        if (!profileLoading && profile && !isFatturazioneConfirmed && formData.skip_generate_document !== true) {
            setFormData(prev => ({ ...prev, skip_generate_document: true }));
        }
    }, [profileLoading, profile, isFatturazioneConfirmed, formData.skip_generate_document]);

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : (selectedOption ? selectedOption.value : '');
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const deleteDetail = (row) => {
        setOnContinue(() => () => continueDelete(row));
        setConfirmShowed(true);
        setConfirmTitle("Eliminare l'acquisto?");
        setConfirmLabel('Elimina');
        setConfirmText("L'acquisto sarà eliminato.");
    };

    const continueDelete = (row) => {
    
        setConfirmShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setCancelledUserLesson(token, row.id, '');
                    setLoadingShowed(false);

                    if(!deleteResult || deleteResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
                        setModalShowed(true);
                    } else {
                        window.history.back();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };

    const paymentDetail = (row) => {
        setOnContinue(() => () => continuePayment(row));
        setConfirmPaymentShowed(true);
    };

    const continuePayment = (row) => {

        console.log(formData);

        if(!formData.modalita_pagamento) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Devi selezionare una modalità di pagamento per procedere.");
            setModalShowed(true);
            return;
        }
    
        setConfirmPaymentShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setPayedUserLesson(token, row.id, formData.modalita_pagamento, formData.skip_generate_document);
                    setLoadingShowed(false);

                    if(!deleteResult || deleteResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
                        setModalShowed(true);
                    } else {
                        window.history.back();
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };

    const refundDetail = (row) => {
        setOnContinue(() => () => continueRefund(row));
        setConfirmShowed(true);
        setConfirmTitle("Rimborsare l'acquisto?");
        setConfirmLabel('Imposta come rimborsato');
        setConfirmText("L'acquisto sarà impostato come rimborsato. Nessun documento verrà emesso.");
    };

    const continueRefund = (row) => {
    
        setConfirmShowed(false);

        const deleteData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.setRefundedUserLesson(token, row.id, '');
                    setLoadingShowed(false);

                    if(!deleteResult || deleteResult.error) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
                        setModalShowed(true);
                    } else {
                        setReloadKey(k => k + 1);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        deleteData();
    };

    return (
        <>
            <Modal className="fade" show={confirmPaymentShowed} centered>
                <Modal.Header>
                    <Modal.Title>Impostare l'acquisto come pagato?</Modal.Title>
                    <Button onClick={() => setConfirmPaymentShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className="col-xl-64">
                            L'acquisto sarà impostato come pagato. <b>Attenzione!</b> Procedendo il corrispondente documento fiscale verrà emesso e inviato se abilitato per la tua struttura.
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col className="col-xl-64">
                            <Form.Label>Modalità di pagamento</Form.Label>
                            <Select
                                placeholder="Seleziona la modalità di pagamento"
                                className="mt-2"
                                name="modalita_pagamento"
                                onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
                                options={optionsPayment}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col className="col-xl-64">
                            <Form.Label>Genera documento</Form.Label>
                            <Select
                                isDisabled={!isFatturazioneConfirmed}
                                className="mt-2"
                                name="skip_generate_document"
                                placeholder="Seleziona"
                                value={[{value: false, label: 'Si'}, {value: true, label: 'No'}].find(option => option.value === formData.skip_generate_document) || null}
                                onChange={(selectedOption) => handleSelectChange(selectedOption, "skip_generate_document")} 
                                options={[{value: false, label: 'Si'}, {value: true, label: 'No'}]}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmPaymentShowed(false)}>
                        Annulla
                    </Button>
                    <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        Imposta come pagato
                    </Button>
                </Modal.Footer>
            </Modal>
            
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>{confirmTitle}</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Annulla
                    </Button>
                    <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
                        {confirmLabel}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Dettagli dell'acquisto</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-lg-6">
                                    <Form.Label>Nome lezione</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="lesson_name	" value={formData.lesson_name	} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Sport</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="sportType" value={sports.find(s => s.value === formData.sportType)?.label || formData.sportType} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Cliente</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="playerName" value={formData.playerName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Junior</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="juniorName" value={formData.juniorName} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Data di inizio</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="startDate" value={formData.startDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                                <Col className="col-lg-6">
                                    <Form.Label>Data di fine</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="endDate" value={formData.endDate} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-lg-6">
                                    <Form.Label>Prezzo</Form.Label>
                                    <Form.Control disabled className="mt-2" type="text" name="price" value={formData.price} style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Fatturazione</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                {/* Selezione Tipo Cliente */}
                                <Col md={12}>
                                    <Form.Label>Tipo Cliente</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="tipo_cliente"
                                        value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                        options={optionsFatturazione}
                                    />
                                </Col>
                            </Row>
                            {/* Azienda */}
                            {formData.tipo_cliente === 'azienda' && (
                                <Row className="mt-4">
                                    <Col lg={4}>
                                        <Form.Label>Ragione sociale</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="ragione_sociale"
                                            value={formData.ragione_sociale}
                                            onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Partita IVA</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="partita_iva"
                                            value={formData.partita_iva}
                                            onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Label>Codice Destinatario (SDI)</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="codice_destinatario"
                                            value={formData.codice_destinatario}
                                            onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}
                            {/* Privato */}
                            {formData.tipo_cliente === 'privato' && (
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="nome"
                                            value={formData.nome}
                                            onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Cognome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="cognome"
                                            value={formData.cognome}
                                            onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                        />
                                    </Col>
                                </Row>
                            )}

                            {/* Campi comuni */}
                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Codice Fiscale</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="codice_fiscale"
                                        value={formData.codice_fiscale}
                                        onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Email PEC / Email</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Indirizzo</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="indirizzo"
                                        value={formData.indirizzo}
                                        onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>CAP</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="cap"
                                        value={formData.cap}
                                        onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                    />
                                </Col>
                                <Col lg={3}>
                                    <Form.Label>Città</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="citta"
                                        value={formData.citta}
                                        onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                    />
                                </Col>
                            </Row>

                            <Row className="mt-4">
                                <Col lg={6}>
                                    <Form.Label>Provincia</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="provincia"
                                        value={italianProvinces.find(option => option.value === formData.provincia)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                        options={italianProvinces}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <Form.Label>Nazione</Form.Label>
                                    <Form.Control
                                        disabled
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                        className="mt-2"
                                        type="text"
                                        name="nazione"
                                        value="Italia"
                                        onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Pagamento</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>Pagato</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="is_pagato"
                                        value={optionsBoolean.find(option => option.value === formData.is_pagato)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "is_pagato")} 
                                        options={optionsBoolean}
                                    />
                                </Col>
                                {formData.is_pagato && ( <Col md={6}>
                                    <Form.Label>Modalità di pagamento</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        name="modalita_pagamento"
                                        value={optionsPayment.find(option => option.value === formData.modalita_pagamento)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "modalita_pagamento")} 
                                        options={optionsPayment}
                                    />
                                </Col> )}
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-xl-3">
                    <Card>
                        <Card.Body className="text-left">
                            {formData.originalStatus==='PAID' && <div>
                            Questo acquisto risulta pagato.
                            <br></br><br></br>
                            Puoi effettuare un rimborso dell'acquisto. Questo causerà una eliminazione dell'acquisto per questo utente.
                            <br></br>
                            <b>Attenzione!</b> In caso di rimborso nessun rimborso economico nè nessun documento fiscale verrà emesso in automatico.
                            </div>}
                            {formData.originalStatus==='UNPAID' && <div>
                            Questo acquisto risulta non pagato.
                            <br></br><br></br>
                            Puoi effettuare una eliminazione dell'acquisto. Questo causerà una eliminazione dell'acquisto per questo utente.
                            <br></br><br></br>
                            Puoi inoltre effettuare una registrazione di pagamento dell'acquisto. <b>Attenzione!</b> Ricorda che in caso di pagamento avvenuto, in questa fase verrà automaticamente generato e inviato il documento fiscale relativo alla tua condizione (quindi fattura o ricevuta in base alla tua natura). <br></br>Ciò avviene solamente se hai abilitato la fatturazione automatica nella sezione "La mia struttura".
                            </div>}
                        </Card.Body>
                    </Card>
                </div>
            </Row>
        </>
    )

}
export default AdminUserLessonsView;